import React, { useState, useEffect, useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import keycloak from '../components/keyclock'; // adjust path as needed
import { useNavigate } from 'react-router-dom';
import { validateUserByEmail } from '../../actions/userActions';
import { ensureContextLoaded } from '../../actions/contextActions';
import { setSession, setSessionJSON } from '../../utils/SessionUtils';


function LoginPage({ onLoginSuccess }) {
  const initialized = useRef(false);
  const navigate = useNavigate();
 
  useEffect(() => {
    if (!initialized.current) {
      keycloak.init({ onLoad: 'login-required' }).then(authenticated => {
        if (authenticated) {
          keycloak.loadUserProfile().then(profile => {
            const token = keycloak.token;
            setSession("KC_TOKEN", token);
            (async () => {
              try {
                await ensureContextLoaded();
              } catch (err) {
                console.error("Failed to load context after login:", err);
              }
              const userData = await validateUserByEmail(profile.email);
              if (userData && userData.userID) {
                setSessionJSON("login-data", userData);
              }
              navigate("/items", { replace: true });
            })();
          });
        }

      });
      initialized.current = true;
    }
  }, []);

  // Optionally show a loading spinner or message
  return (
    <Box sx={{
      position: 'fixed',
      inset: 0,
      background: '#f1f5f9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      {/* Full-screen illustration */}
      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/fulfillment-splash.png`}
        alt="Loading"
        sx={{ width: '100%', height: '100%', objectFit: 'contain' }}
      />
      {/* Loading indicator pinned to bottom */}
      <Box sx={{
        position: 'absolute',
        bottom: 40,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1.5,
      }}>
        <CircularProgress size={36} thickness={4} sx={{ color: '#1a3c6e' }} />
        <Typography sx={{ fontSize: 13, color: '#64748b', fontWeight: 500, letterSpacing: 0.3 }}>
          Redirecting to sign in&hellip;
        </Typography>
      </Box>
    </Box>
  );
}

export default LoginPage;